import _ from 'lodash';
import { Label, LabelSetting } from '../types/label';
import { Store } from './Store';
import { generateUUID } from '../lib/util';

const setLabels = (store: Store, labels: Label[]) => {
  store.setState({ labels: labels });
};

const setProperties = (store: Store, properties: { tag: string; annotationState: string }) => {
  store.setState({ properties: properties });
};

const setTags = (store: Store, tags: string[]) => {
  store.setState({ tags: tags });
};

const addLabel = (store: Store, label: Label) => {
  label.color = label.color ? label.color : store.state.labels.filter(l => l.name === label.name)[0].color;
  const labels = [...store.state.labels.filter(l => !(l.name === label.name && !l.word)), label];
  store.setState({ labels });
  return labels;
};

const acceptLabel = (store: Store, labelToAccept: Label) => {
  const labels = store.state.labels;

  const updatedLabels = labels.map(label =>
    label.id === labelToAccept.id
      ? {
          ...labelToAccept,
          manuallyApproved: true,
          reliable: true,
          exists: true,
        }
      : label
  );
  store.setState({ labels: updatedLabels });
  return updatedLabels;
};

const editLabel = (store: Store, label: Label) => {
  const labels = store.state.labels;

  var updatedLabels = labels.map(l => (l.id === label.id ? { ...l, ...label } : l));

  store.setState({ labels: updatedLabels });
  return updatedLabels;
};

const removeLabel = (store: Store, label: Label) => {
  var labels = _.cloneDeep(store.state.labels);
  if (store.state.labels.filter(l => l.name === label.name).length > 1) {
    labels = labels.filter(l => l.id !== label.id);
    store.setState({ labels: labels });
    return labels;
  }
  const labelToChange = labels.find(l => l.id === label.id);
  if (!labelToChange) return;

  labelToChange.exists = false;
  labelToChange.reliable = true;
  labelToChange.source = 'detected';
  labelToChange.location = null;
  labelToChange.word = null;
  labelToChange.page = null;
  labelToChange.manuallyApproved = false;

  store.setState({ labels: labels });
  return labels;
};

const removeLabels = (store: Store) => {
  store.setState({ labels: [] });
};

const setLabelEdit = (store: Store, label: Label) => {
  store.setState({ labelEdit: label });
};

const setLabelEditCopied = (store: Store, value: boolean) => {
  store.setState({ labelEditCopied: value });
};

const setLabelSelected = (store: Store, label: Label) => {
  store.setState({ labelSelected: label });
};

const setTagEdit = (store: Store, tagedit: boolean) => {
  store.setState({ tagEdit: tagedit });
};

const setReadOnly = (store: Store, readOnly: boolean) => {
  store.setState({ readOnly: readOnly });
};

const setContainer = (store: Store, container: HTMLElement) => {
  store.setState({ container: container });
};

const setLabelOptions = (store: Store, labelOptions: LabelSetting[]) => {
  store.setState({ labelOptions });
};

const addToLabelHistory = (store: Store, label: Label) => {
  const labels = [...store.state.labelHistory, label];
  store.setState({ labelHistory: labels });
};

const removeFromLabelHistory = (store: Store) => {
  const labels = store.state.labelHistory.slice(0, -1);
  store.setState({ labelHistory: labels });
};

const clearLabelHistory = (store: Store) => {
  store.setState({ labelHistory: [] });
};

const setAllLabels = (store: Store, allLabels: boolean) => {
  store.setState({ allLabels: allLabels });
};

const doRefreshOverview = (store: Store) => {
  store.setState({ refreshOverview: generateUUID() });
};

export const actions = {
  setProperties,
  setLabels,
  addLabel,
  acceptLabel,
  editLabel,
  removeLabel,
  removeLabels,
  setLabelEdit,
  setLabelEditCopied,
  setLabelSelected,
  setReadOnly,
  setContainer,
  setLabelOptions,
  setTags,
  setTagEdit,
  addToLabelHistory,
  removeFromLabelHistory,
  clearLabelHistory,
  setAllLabels,
  doRefreshOverview,
};
